export default __webpack_public_path__ + "static/media/area-48.89899840.jpg";